export const CASHFLOW_PROJECTION_MODAL_TITLE = 'Cash flow projection'
export const CASHFLOW_PROJECTION_MODAL_TITLE_NEW = 'New cash flow projection'
